module.exports = __webpack_public_path__ + "media/images/top/pap/icon/gray/ico_arrow_up-9f85809909f2c5215c7cbdfa62ffaf30.svg";